import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import {
  fetchGetInfrastructureMicrofrontend,
  TGetInfrastructureMicrofrontendRequest,
  TGetInfrastructureMicrofrontendResponse,
} from 'shared/repositories/map-search-frontend/v1/get-infrastructure-microfrontend';
import { IApplicationContext } from 'shared/types/applicationContext';

interface IGetInfrastructureMicrofrontendManifestOptions {
  timeoutMs?: number;
}

export async function getInfrastructureMicrofrontendManifest(
  { httpApi, logger, telemetry }: IApplicationContext,
  parameters: TGetInfrastructureMicrofrontendRequest,
  options: IGetInfrastructureMicrofrontendManifestOptions = {},
): Promise<IMicrofrontendManifest | null> {
  const { timeoutMs } = options;
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  try {
    const responsePromise: Promise<TGetInfrastructureMicrofrontendResponse> = fetchGetInfrastructureMicrofrontend({
      httpApi,
      parameters,
    });

    if (!timeoutMs) {
      const res: TGetInfrastructureMicrofrontendResponse = await responsePromise;

      return res.response.manifest;
    }

    const timeoutPromise = new Promise<null>(resolve => {
      timeoutId = setTimeout(() => resolve(null), timeoutMs);
    });
    const res: TGetInfrastructureMicrofrontendResponse | null = await Promise.race([
      responsePromise,
      timeoutPromise,
    ]);

    if (res === null) {
      logger.warning(new Error('Таймаут получения манифеста микрофронта инфраструктуры'), {
        domain: 'getInfrastructureMicrofrontendManifest',
        message: 'Таймаут получения манифеста микрофронта инфраструктуры',
        timeoutMs,
      });
      telemetry.increment('infrastructure-microfrontend-fetch-timeout');

      return null;
    }

    return res.response.manifest;
  } catch (e) {
    logger.warning(e, {
      domain: 'getInfrastructureMicrofrontendManifest',
      message: 'Ошибка получения манифеста микрофронта инфраструктуры',
      timeoutMs,
    });

    telemetry.increment('infrastructure-microfrontend-fetch-error');

    return null;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
}
